export default "__VITE_ASSET__CeOwouPC__"